import client from "./client";

// 회원 가입
export const selectInvest = ({ no }) =>
  client.post("/api/invest_select_farm", {
    no,
  });
